import sift from 'sift';

const InvoiceBucketLabelMap = {
  consignment_invoice_all: { label: 'ALL' },
  consignment_invoice_pending: { label: 'Pending' },
  consignment_invoice_in_review: { label: 'In Review' },
  consignment_invoice_approved: { label: 'Approved' },
  consignment_invoice_rejected: { label: 'Rejected' },
};

const invoiceSearchOptions = [
  { value: 'consignmentReferenceNumber', label: 'Consignment Number' },
  { value: 'invoiceNumber', label: 'Invoice Number' },
  { value: 'tripReferenceNumber', label: 'Trip Reference Number' },
];

const movementTypeFilterOptions = [
  { value: 'forward', label: 'Forward' },
  { value: 'reverse', label: 'Reverse' },
];

const podStatusFilterOptions = [
  { value: 'PENDING', label: 'Pending' },
  { value: 'IN_REVIEW', label: 'In Review' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'REJECTED', label: 'Rejected' },
];

const dateFilterOptions = [
  { value: 'created_at', label: 'Created At' },
  { value: 'updated_at', label: 'Updated At' },
];

const imageUploadOptions = [
  { value: 'override_pod', label: 'Override it' },
  { value: 'skip', label: 'Skip and do nothing' },
  { value: 'apend_pod', label: 'Add the additional image (max limit upto 4)' },
];

const pieceStatusPrettyNameMapping = {
  delivered: 'Delivered',
  undelivered: 'Undelivered',
  pickup_completed: 'Pickup Completed',
  attempted: 'Undelivered',
  not_picked_up: 'Not Picked Up',
};

const paginationOptions = [100, 50, 20, 10];

const statusesPrettyNameMapping = {
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
  IN_REVIEW: 'In Review',
};

const getRequiredInvoiceConfig = (filterConfig: any[], data: any): any => {
  if (!filterConfig || !data) return {};

  const matchedConfig = filterConfig.find((config) => {
    const { when } = config || {};
    if (!when) return true;

    const whenSiftFunc = sift(when);
    return whenSiftFunc(data);
  });

  return matchedConfig?.what || {};
};

export {
  InvoiceBucketLabelMap,
  invoiceSearchOptions,
  movementTypeFilterOptions,
  podStatusFilterOptions,
  dateFilterOptions,
  paginationOptions,
  imageUploadOptions,
  statusesPrettyNameMapping,
  pieceStatusPrettyNameMapping,
  getRequiredInvoiceConfig,
};
